import { useEffect, useMemo, useRef, useState } from 'react'
import lozad from 'lozad'

import { getMobileOS } from 'lib/helpers'
import { Post } from 'lib/_types'

import ImageLoader from 'components/ImageLoader'

import './style.scss'

const observer = lozad()

type PostVideoProps = {
  post?: Post
  isShared?: boolean
}

const PostVideo = ({ post, isShared }: PostVideoProps) => {
  const video = useMemo(() => post.videos[0], [post])
  const { video_url, width, height, thumbnail_url } = video
  const [videoHeight, setVideoHeight] = useState(320)
  const wrapperRef = useRef(null)

  useEffect(() => {
    if (thumbnail_url !== null) {
      observer.observe()
    }
  }, [thumbnail_url])

  // https://jira.nanameue.jp/browse/YAY-6147
  useEffect(() => {
    if (
      typeof width !== 'number' ||
      typeof height !== 'number' ||
      wrapperRef.current === null
    )
      return

    let ratio = 1
    if (width > height) {
      ratio = 0.5 // ratio 2:1
    } else if (width < height) {
      ratio = 1.33 // ratio 3:4
    }

    setVideoHeight(wrapperRef.current.clientWidth * ratio)
  }, [width, height])

  const autoPlay = getMobileOS() !== 'Android' && getMobileOS() !== 'iOS'

  if (isShared && post?.text?.length !== 0) {
    return (
      <div className="PostVideo PostVideo--shared">
        <ImageLoader url={thumbnail_url} />
        <img
          src="/images/icon-play.svg"
          alt="Video media"
          className="PostVideo__play__icon"
        />
      </div>
    )
  }

  return (
    <div
      className="PostVideo"
      style={{ height: `${videoHeight}px` }}
      ref={wrapperRef}
    >
      <video
        className="lozad"
        width="100%"
        height={videoHeight}
        preload="none"
        autoPlay={autoPlay}
        muted={autoPlay} // video can auto play when it's muted
        data-poster={thumbnail_url}
        controls
      >
        <source src={video_url} />
      </video>
    </div>
  )
}

export default (props) => {
  const hasVideo = Boolean(props.post?.videos?.[0])
  return hasVideo ? <PostVideo {...props} /> : null
}
